import './styles.css'

export const Frame = ({ children, className = '', ...props }) => {
  return (
    <div className={`frame ${className}`} {...props}>
      {children}
    </div>
  )
}
